import React, { useState } from "react";
import "./Dashboard.css";
import { FaShoppingCart, FaBoxOpen, FaCubes, FaChartLine } from "react-icons/fa";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, } from "recharts";


const generateDailyData = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth(); // 0 = Jan

  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const dailyData = [];

  for (let day = 1; day <= daysInMonth; day++) {
    dailyData.push({
      name: `${day}/${month + 1}`, // Example: "1/12"
      orders: Math.floor(Math.random() * 50) + 5, // sample values
    });
  }

  return dailyData;
};

const Dashboard = () => {
  const [filter, setFilter] = useState("monthly");

  // SAMPLE DATA (replace with API later)
  const dataOptions = {
  monthly: [
    { name: "Jan", orders: 40 },
    { name: "Feb", orders: 55 },
    { name: "Mar", orders: 30 },
    { name: "Apr", orders: 70 },
    { name: "May", orders: 45 },
  ],
  daily: generateDailyData(),  // FULL MONTH AUTO GENERATED
  yearly: [
    { name: "2021", orders: 300 },
    { name: "2022", orders: 420 },
    { name: "2023", orders: 510 },
    { name: "2024", orders: 610 },
  ],
};


  return (
    <div className="dashboard-container">
      
      {/* CARDS ROW */}
      <div className="cards-row">
        
        {/* CARD 1 - ACTIVE ORDERS */}
        <div className="dash-card">
          <div className="card-icon" style={{ backgroundColor: "#e7f0ff" }}>
            <FaShoppingCart color="#568ddf" size={24} />
          </div>
          <div>
            <h3>Active Orders</h3>
            <p className="card-value">3 / 10</p>
            <span className="card-sub">Today / Total</span>
          </div>
        </div>

        {/* CARD 2 - LOW STOCK PREBUILT */}
        <div className="dash-card">
          <div className="card-icon" style={{ backgroundColor: "#fff4e5" }}>
            <FaBoxOpen color="#ff9f43" size={24} />
          </div>
          <div>
            <h3>Low Stock (Prebuilt)</h3>
            <p className="card-value">6</p>
            <span className="card-sub">Units Critical</span>
          </div>
        </div>

        {/* CARD 3 - LOW STOCK COMPONENTS */}
        <div className="dash-card">
          <div className="card-icon" style={{ backgroundColor: "#eafaf1" }}>
            <FaCubes color="#27ae60" size={24} />
          </div>
          <div>
            <h3>Low Stock (Components)</h3>
            <p className="card-value">14</p>
            <span className="card-sub">Items Critical</span>
          </div>
        </div>

        {/* CARD 4 - TOP SELLING */}
        <div className="dash-card">
          <div className="card-icon" style={{ backgroundColor: "#f7eaff" }}>
            <FaChartLine color="#9b59b6" size={24} />
          </div>
          <div>
            <h3>Top Sales</h3>
            <p className="card-value">#1 Cosmic 512GB</p>
            <span className="card-sub">Top 3 Products</span>
          </div>
        </div>

      </div>

      {/* CHART SECTION */}
      <div className="chart-wrapper">
        <div className="chart-header">
          <h2>Orders Overview</h2>

          <select
            className="chart-select"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="monthly">Monthly</option>
            <option value="daily">Daily</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>

        <div className="chart-box">
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={dataOptions[filter]}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="orders" fill="#568ddf" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

    </div>
  );
};

export default Dashboard;
